<div *ngFor="let s of sizes" class="invisible {{ s.css + ' ' + (prefix + s.id) }}"></div>
<div class="flex h-full">
  <div class="w-1/4" *ngIf="assetViewTypeService.getGridSettings('showGridViewSidebar', gridSettingsKeySuffix)">
    <thehubz-assets-sidebar
      *ngIf="selectedFilterObject"
      id="assets-sidebar"
      [configObject]="configObject"
      [filterAssetFormData]="filterCollectionFormData"
      [appliedFilters]="appliedFilters"
      [gridSettingsKeySuffix]="gridSettingsKeySuffix"
      [selectedFilterObject]="selectedFilterObject"
      [formResetter]="formResetter.asObservable()"
      (applyFilters)="applyFilters($event)"
      (updateFormData)="updateFormData($event)"
      (viewAssetTags)="viewAssetTags()"
    ></thehubz-assets-sidebar>
  </div>
  <div
    *ngIf="assetViewTypeService.getGridSettings('showGridView', gridSettingsKeySuffix)"
    class="w-full flex flex-col"
    [ngClass]="!httpCallInProgress && !filteredList.length ? '!h-[1px]' : 'h-[100%]'"
  >
    <div *ngIf="showFilterBubbles" class="applied-filter-container">
      <sp-chips-listbox-option
        [dataSource]="filterBubbles"
        [clearAllChip]="true"
        [highlighted]="false"
        [selectable]="false"
        (removeChip)="removeFilterBubble($event)"
        (removeChips)="removeAllFilterBubble()"
      ></sp-chips-listbox-option>
    </div>
    <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
    <ng-template #loadingComplete>
      <thehubz-asset-gallery-view
        *ngIf="!loading && !showEmptyState"
        [configObject]="configObject"
        [imageObject]="filteredList"
        [imageSplitObject]="filteredSplitList"
        [currentSize]="currentSize"
        [filterObject]="filterObject"
        [collectionOwner]="isOwner"
        [itemSize]="itemSize"
        [assetCount]="assetCount"
        [offset]="offset"
        [gridSettingsKeySuffix]="gridSettingsKeySuffix"
        [size]="size"
        [collectionFlag]="collectionFlag"
        (addRemoveFromBasket)="addRemoveFromBasket($event)"
        (editAssets)="editAssets($event)"
        (downloadAsset)="downloadAsset($event.asset)"
        (viewportScrolled)="onAssetScroll($event)"
      >
      </thehubz-asset-gallery-view>
    </ng-template>
    <div *ngIf="!httpCallInProgress && showEmptyState" class="ml-3 pr-3">
      <sp-blank-page pageType="assets"></sp-blank-page>
    </div>
  </div>
  <div *ngIf="assetViewTypeService.getGridSettings('showListView', gridSettingsKeySuffix)" class="w-full" [ngClass]="!httpCallInProgress && !filteredList.length ? '!h-[1px]' : 'h-[100%]'">
    <div *ngIf="showFilterBubbles">
      <sp-chips-listbox-option
        [dataSource]="filterBubbles"
        [clearAllChip]="true"
        [highlighted]="false"
        [selectable]="false"
        (removeChip)="removeFilterBubble($event)"
        (removeChips)="removeAllFilterBubble()"
      ></sp-chips-listbox-option>
    </div>
    <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete1" [showSpinner]="true"></sp-loading-inprogress>
    <ng-template #loadingComplete1>
      <thehubz-asset-listview
        *ngIf="!loading && !showEmptyState"
        [assetData]="filteredList"
        [filterObject]="filterObject"
        [configObject]="configObject"
        [tableColumnData]="tableColumnData"
        [assetCount]="assetCount"
        [collectionOwner]="isOwner"
        (changeView)="changeAssetView($event)"
        (tableScrolled)="onAssetScroll($event)"
        [loading]="loading"
        [offset]="offset"
        [gridSettingsKeySuffix]="gridSettingsKeySuffix"
        [collectionFlag]="collectionFlag"
        (editAssets)="editAssets($event)"
        (downloadAsset)="downloadAsset($event.asset)"
        (updateCollectionAssets)="selectCollectionAsset($event)"
        [tableType]="'asset'"
        [selectedTabKey]="selectedTabKey"
        (tableData)="collectionEventsService.collectionTableDataSubject$.next($event)"
      >
      </thehubz-asset-listview>
    </ng-template>
    <div *ngIf="!httpCallInProgress && showEmptyState" class="ml-3 pr-3">
      <sp-blank-page pageType="assets"></sp-blank-page>
    </div>
    <div *ngIf="loading" class="spinner-item">
      <mat-progress-spinner [mode]="'indeterminate'" [diameter]="50"></mat-progress-spinner>
    </div>
  </div>
</div>
